import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { InvoiceSchema } from '../base/index.js';
export const DeleteInvoicePathRequestSchema = z.object({});
export const DeleteInvoiceApiSchema = {
    params: z.object({
        entityId: CornSchema,
        invoiceId: z.string(),
    }),
    headers: z.object({ requestActor: z.string() }),
    response: InvoiceSchema.optional(),
};
export const DeleteInvoicePathSchema = DeleteInvoiceApiSchema.params;
export const DeleteInvoiceHeadersSchema = DeleteInvoiceApiSchema.headers;
export const DeleteInvoiceRequestSchema = DeleteInvoiceApiSchema.headers.merge(DeleteInvoiceApiSchema.params);
export const DeleteInvoiceResponseSchema = DeleteInvoiceApiSchema.response;
